
import { defineComponent, ref } from 'vue';

import { useCalculations } from '@/lib/calculationstate';
import Button, { ButtonType } from '@/components/Button.vue';
import download from '@/lib/download';
import { useYearlyGraphs } from '@/lib/graphs';

export default defineComponent({
  name: 'PdfDownloadButton',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      ButtonType,
    };
  },
  setup() {
    const { state } = useCalculations();
    const graphs = useYearlyGraphs();

    const isDownloading = ref(false);
    const downloadPdf = async () => {
      isDownloading.value = true;
      const createPdf = (await import('@/lib/pdf/pdf.ts')).default;
      const pdf = await createPdf(state, graphs);
      download(pdf, 'wia-berekeningen.pdf');
      isDownloading.value = false;
    };

    return {
      isDownloading,
      downloadPdf,
    };
  },
});
